import {createEffect} from 'effector';
import api from '../../api/api.js';
import axios from 'axios';

export const getApplicationsFx = createEffect()
    .use(async (query) => (await api().get(`applications/?${query}`)).data);

export const getMyApplicationsFx = createEffect()
    .use(async (query) => (await api().get(`applications/my/?${query}`)).data);

export const getApplicationByIdFx = createEffect()
    .use(async (id) => (await api().get(`applications/${id}/`)).data);

export const updateApplicationFx = createEffect()
    .use(async ({id, data}) => (await api().put(`applications/${id}/`, data)).data);

export const getAppCategoriesFx = createEffect()
.use(async () => (await api().get('application_categories/')).data);

export const downloadAppFileFx = createEffect()
    .use(async ({path, name}) => {
        const file = await axios.get(path, {responseType: 'blob'})
        const link = document.createElement('a')
        const url = URL.createObjectURL(file.data)
        link.href = url
        link.target = '_blank'
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    })